/*
 * BaePink: calculadora de envio del carrito (carrito lateral y pagina /cart).
 *
 * Reemplaza el calculo del tema Broadcast, que mostraba mal los montos en CLP
 * (una tarifa de $12.990 aparecia como $130: trataba pesos como centavos)
 * y no mostraba fecha estimada de entrega.
 *
 * - Pide las tarifas reales a Shopify (/cart/prepare_shipping_rates.json +
 *   /cart/async_shipping_rates.json) con los datos del formulario.
 * - Formatea el precio en CLP ("$12.990"; 0 = "Gratis").
 * - Fecha estimada: usa la que entregue Shopify si existe; si no, la calcula
 *   con los plazos publicados en la politica de envio (dias habiles, sin
 *   sabados, domingos ni feriados).
 * - Oculta el campo "Codigo postal" (en Chile las tarifas van por region/comuna).
 *
 * Para desactivarlo: quitar la linea de este archivo en layout/theme.liquid.
 */
(function () {
  'use strict';

  // Dias habiles desde la compra [minimo, maximo], segun la politica de envio.
  // RM: delivery 1 a 2 dias. Valparaiso: delivery Quinta 1 a 3 dias.
  // Resto: Starken, despacho el dia habil siguiente + transito por region.
  var TRANSIT = [
    { keys: ['metropolitan', 'metropolitana', 'santiago'], range: [1, 2] },
    { keys: ['valparaiso'], range: [1, 3] },
    { keys: ['arica', 'tarapaca'], range: [4, 5] },
    { keys: ['antofagasta'], range: [3, 4] },
    { keys: ['aysen', 'aisen', 'magallanes'], range: null },
    { keys: ['atacama', 'coquimbo', 'higgins', 'maule', 'nuble', 'bio', 'araucania', 'rios', 'lagos'], range: [2, 3] }
  ];

  var FERIADOS = []; // opcional: fechas 'AAAA-MM-DD' que no cuentan como dia habil

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function ymd(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }

  function isBusinessDay(d) {
    var wd = d.getDay();
    return wd !== 0 && wd !== 6 && FERIADOS.indexOf(ymd(d)) === -1;
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) n--;
    }
    return d;
  }

  function parseDate(s) {
    var p = String(s || '').slice(0, 10).split('-');
    if (p.length !== 3) return null;
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(d.getTime()) ? null : d;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      return ymd(d);
    }
  }

  function fmtMoney(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return esc(amount);
    if (n === 0) return (window.theme && window.theme.strings && window.theme.strings.free) || 'Gratis';
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency', currency: currency || 'CLP', minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function regionRange(province) {
    var p = norm(province);
    if (!p) return undefined;
    for (var i = 0; i < TRANSIT.length; i++) {
      for (var k = 0; k < TRANSIT[i].keys.length; k++) {
        if (p.indexOf(TRANSIT[i].keys[k]) !== -1) return TRANSIT[i].range;
      }
    }
    return undefined;
  }

  function etaText(rate, province) {
    var from = null, to = null;
    if (rate.delivery_range && rate.delivery_range.length) {
      from = parseDate(rate.delivery_range[0]);
      to = parseDate(rate.delivery_range[rate.delivery_range.length - 1]);
    } else if (rate.delivery_date) {
      from = to = parseDate(rate.delivery_date);
    }
    if (!from) {
      var range = regionRange(province);
      if (range === null) return 'Plazo de entrega a confirmar con Starken para esta regi\u00f3n.';
      if (!range) return '';
      var today = new Date();
      from = addBusinessDays(today, range[0]);
      to = addBusinessDays(today, range[1]);
    }
    if (!to || ymd(from) === ymd(to)) return 'Llega aprox. el ' + fmtDate(from) + '.';
    return 'Llega aprox. entre el ' + fmtDate(from) + ' y el ' + fmtDate(to) + '.';
  }

  function readAddress(calc) {
    var country = calc.querySelector('#address_country, [name="address[country]"]');
    var province = calc.querySelector('#address_province, [name="address[province]"]');
    var provText = '';
    if (province && province.selectedIndex > -1 && province.options[province.selectedIndex]) {
      provText = province.options[province.selectedIndex].text;
    }
    return {
      country: (country && country.value) || 'Chile',
      province: (province && province.value) || '',
      provinceLabel: provText || (province && province.value) || '',
      zip: ''
    };
  }

  function query(addr) {
    var e = encodeURIComponent;
    return 'shipping_address%5Bzip%5D=' + e(addr.zip) +
      '&shipping_address%5Bcountry%5D=' + e(addr.country) +
      '&shipping_address%5Bprovince%5D=' + e(addr.province);
  }

  function root() {
    return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  }

  function readError(res) {
    return res.json().then(function (j) { throw j || {}; }, function () { throw {}; });
  }

  function poll(q, n) {
    return fetch(root() + 'cart/async_shipping_rates.json?' + q, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (res.status === 200) return res.json();
      if (res.status === 202 && n < 20) {
        return new Promise(function (r) { setTimeout(r, 500); }).then(function () { return poll(q, n + 1); });
      }
      return readError(res);
    });
  }

  function getRates(addr) {
    var q = query(addr);
    return fetch(root() + 'cart/prepare_shipping_rates.json?' + q, {
      method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok && res.status !== 202) return readError(res);
      return poll(q, 0);
    });
  }

  function errorText(err) {
    var msgs = [];
    if (err && typeof err === 'object') {
      Object.keys(err).forEach(function (k) {
        var v = err[k];
        if (Array.isArray(v)) v.forEach(function (m) { msgs.push(m); });
        else if (typeof v === 'string') msgs.push(v);
      });
    }
    return msgs.length ? msgs.join(' ') : 'No pudimos calcular el env\u00edo. Intenta de nuevo o escr\u00edbenos.';
  }

  function show(wrapper, html) {
    wrapper.innerHTML = html;
    wrapper.style.display = 'block';
    wrapper.style.opacity = '1';
    wrapper.style.visibility = 'visible';
    wrapper.style.height = 'auto';
  }

  function render(calc, rates, addr) {
    if (!rates || !rates.length) {
      return '<div class="bp-rates" data-bp-rates><p class="bp-rates__msg">' +
        'No hay env\u00edos disponibles para esta direcci\u00f3n. Escr\u00edbenos y lo vemos.</p></div>';
    }
    var items = rates.map(function (r) {
      var eta = etaText(r, addr.provinceLabel || addr.province);
      return '<li class="bp-rates__item"><div class="bp-rates__row"><span class="bp-rates__name">' +
        esc(r.presentment_name || r.name) + '</span><strong class="bp-rates__price">' +
        fmtMoney(r.price, r.currency) + '</strong></div>' +
        (eta ? '<div class="bp-rates__eta">' + esc(eta) + '</div>' : '') + '</li>';
    }).join('');
    return '<div class="bp-rates" data-bp-rates><ul class="bp-rates__list">' + items + '</ul>' +
      '<p class="bp-rates__note">Fechas estimadas en d\u00edas h\u00e1biles desde la compra. Pueden variar seg\u00fan la comuna.</p></div>';
  }

  function calculate(calc, btn) {
    if (calc.__bpBusy) return;
    var wrapper = calc.querySelector('#wrapper-response') || calc.querySelector('.fade-toggle');
    if (!wrapper) return;
    hideZip();
    var addr = readAddress(calc);
    var label = btn ? btn.innerHTML : '';
    calc.__bpBusy = true;
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = (window.theme && window.theme.strings && window.theme.strings.shippingCalcSubmitButtonDisabled) || 'Calculando...';
    }
    getRates(addr).then(function (data) {
      calc.__bpLast = render(calc, (data && data.shipping_rates) || [], addr);
    }, function (err) {
      calc.__bpLast = '<div class="bp-rates" data-bp-rates><p class="bp-rates__msg bp-rates__msg--error">' + esc(errorText(err)) + '</p></div>';
    }).then(function () {
      show(wrapper, calc.__bpLast);
      calc.__bpBusy = false;
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      watch(calc, wrapper);
    });
  }

  // Si el tema vuelve a escribir su resultado (con el monto mal), se reemplaza por el nuestro.
  function watch(calc, wrapper) {
    if (calc.__bpObserver || !window.MutationObserver) return;
    calc.__bpObserver = new MutationObserver(function () {
      if (calc.__bpBusy || wrapper.querySelector('[data-bp-rates]')) return;
      if (!wrapper.textContent.trim()) return;
      if (calc.__bpLast) show(wrapper, calc.__bpLast);
    });
    calc.__bpObserver.observe(wrapper, { childList: true, subtree: true });
  }

  // Oculta el campo "Codigo postal" (respaldo para navegadores sin soporte de :has).
  function hideZip() {
    var fields = document.querySelectorAll('shipping-calculator #address_zip, .shipping-calculator #address_zip');
    for (var i = 0; i < fields.length; i++) {
      var box = fields[i].closest('.p') || fields[i].parentNode;
      if (box && box.style.display !== 'none') box.style.display = 'none';
    }
  }

  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.get-rates') : null;
    if (!btn) return;
    var calc = btn.closest('shipping-calculator') || btn.closest('.shipping-calculator');
    if (!calc) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    calculate(calc, btn);
  }, true);

  var css = document.createElement('style');
  css.textContent =
    'shipping-calculator .p:has(#address_zip),.shipping-calculator .p:has(#address_zip){display:none!important}' +
    '.bp-rates{margin-top:14px}' +
    '.bp-rates__list{list-style:none;margin:0;padding:0}' +
    '.bp-rates__item{padding:10px 0;border-bottom:1px solid rgba(0,0,0,.08)}' +
    '.bp-rates__item:last-child{border-bottom:0}' +
    '.bp-rates__row{display:flex;justify-content:space-between;gap:12px;align-items:baseline}' +
    '.bp-rates__price{white-space:nowrap}' +
    '.bp-rates__eta{margin-top:4px;font-size:13px;color:#d12f78}' +
    '.bp-rates__eta::first-letter{text-transform:uppercase}' +
    '.bp-rates__note{margin:8px 0 0;font-size:12px;opacity:.75}' +
    '.bp-rates__msg{margin:0;font-size:14px}' +
    '.bp-rates__msg--error{color:#c0392b}';
  document.head.appendChild(css);

  hideZip();
  document.addEventListener('DOMContentLoaded', hideZip);
  window.addEventListener('load', hideZip);
  document.addEventListener('click', function () { setTimeout(hideZip, 300); });
})();
